import styled, { css } from 'styled-components';
import { Box } from '@mui/material';
import { colors } from '@/globalStyles';

export const HeaderStyled = styled.div`
  display: grid;
  grid-template-columns: max-content 1fr max-content;
  padding: 30px;
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.2);
  background-color: ${colors.white};
  z-index: 1;
`;

export const IconWrapperStyled = styled(Box)`
  width: 30px;
  height: 30px;

  ${props => {
    if (props.$disabled) {
      return css`
        opacity: 0.5;
        cursor: default;
      `;
    }
    return css`
      opacity: 1;
      cursor: pointer;

      &:hover {
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
        border-radius: 4px;
      }

      &:active {
        color: ${colors.primary} !important;
      }
    `;
  }}
`;
